import { CalendarDay, isCalendarDay } from '@shared/models/dateTypes';
import { REPEAT_INTERVALS, RepeatInterval } from './repeat-days.util';
import { readStoredJson, writeStored } from '@shared/utilities/stored';

/** The basket's last "Gentag" and "Gentag til" (#1138) — a per-browser convenience. */
const REMEMBERED_KEY = 'abook-repeat-last-choice';

export interface RepeatChoice {
  interval: RepeatInterval;
  end: CalendarDay | null;
}

/**
 * The last choice, for a time starting `start`: the interval as it was, the last day only when it
 * still lies after the time — an old one would find no dates. Nothing remembered (or unreadable)
 * gives null for each.
 */
export function readRepeatChoice(start: CalendarDay): {
  interval: RepeatInterval | null;
  end: CalendarDay | null;
} {
  const parsed = readStoredJson(REMEMBERED_KEY);
  const value = parsed && typeof parsed === 'object' ? (parsed as Partial<RepeatChoice>) : null;
  const interval = REPEAT_INTERVALS.some((option) => option.value === value?.interval)
    ? (value!.interval as RepeatInterval)
    : null;
  const end = isCalendarDay(value?.end) && value!.end > start ? value!.end : null;
  return { interval, end };
}

export function rememberRepeatChoice(choice: RepeatChoice): void {
  writeStored(REMEMBERED_KEY, choice);
}
